
uniform float uTime;
uniform sampler2D uPerlinTexture;

varying vec2 vUv;

#include ../includes/rotate2D.glsl

void main(){
  vec3 newPosition = position;

  // * Twist
  float rotationValue = texture(
    uPerlinTexture, 
    vec2(0.5, uv.y * 0.2 - uTime * 0.005)
  ).r;
  float angle = rotationValue * 10.0;
  newPosition.xz = rotate2D(newPosition.xz,  angle);

  // * windOffset
  vec2 windOffset = vec2(
    texture(uPerlinTexture, vec2(0.25, uTime * 0.01)).r - 0.5,
    texture(uPerlinTexture, vec2(0.75, uTime * 0.01)).r - 0.5
  );

  windOffset *= pow(uv.y, 3.0) * 10.0;

  newPosition.xz += windOffset;
  
  // * Final position
  gl_Position = projectionMatrix * modelViewMatrix * vec4(newPosition, 1.0);

  // * Varyings
  vUv = uv;
}